import React from "react";
import { IVideoModel } from "shared-types";
import cx from "classnames";
import {
  formatTime,
  transformMillisecToSec,
} from "../../../../../generics/time-formatting";
import { MediaPlaySkinnyIcon } from "assets";
import "./ThumbnailVideo.scss";

export interface IThumbnailVideoProps {
  selectVideo: (video: IVideoModel) => void;
  video: IVideoModel;
  isActive: boolean;
}

export const ThumbnailVideo: React.FC<
  React.PropsWithChildren<IThumbnailVideoProps>
> = (props) => {
  const { selectVideo, video, isActive } = props;
  const selectVideoWrapper = () => selectVideo(video);

  return (
    <div
      className={cx("c-thumbnail-video", {
        "c-thumbnail-video--playing-video": isActive,
      })}
      data-active={isActive}
      onClick={selectVideoWrapper}
    >
      <div
        className="c-thumbnail-video__play-icon"
        style={{ backgroundImage: `url(${video.previewImg})` }}
      >
        <MediaPlaySkinnyIcon className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" />
      </div>
      <div className="c-thumbnail-video__file-name">{video.fileName}</div>
      <p className="c-thumbnail-video__video-duration">
        {formatTime(transformMillisecToSec(video.duration), ".")}
      </p>
    </div>
  );
};
